import errorParser from "../../utils/errorParser";
import RestResourceService from "@/services/RestResourceService";

function initialState() {
    return {
        result: ''
    }
}

export default {
    state: initialState(),
    getters: {
        JSON_PATH_RESULT: state => {
            return state.result
        },
    },
    mutations: {
        SET_JSON_PATH_RESULT(state, payload) {
            state.result = payload;
        },
        RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        }
    },
    actions: {
        POST_JSON_PATH: async (context, payload) => {
            return RestResourceService.postResources('/api/v1/jsonpath/evaluate/quasiris/json-path', payload.form)
                .then((response) => {
                    const result = JSON.parse(response.data.result);
                    context.commit('SET_JSON_PATH_RESULT', JSON.stringify(result, undefined, 4));
                })
                .catch((error) => {
                    errorParser.parse(error);
                    throw new Error(error);
                })
        },
        RESET: (context) => {
            context.commit('RESET');
        },
    }
}
